import { isNullable } from '@app/utils'

import type { CommonQuotaFormHierarchyKeys } from './types'
import type { QuotaReportDirectoryDataSource } from '@app/pages/QuotaReportPage/Tabs/DirectoryTab/types'

export const getHierarchyKey = (
  dataSource?: QuotaReportDirectoryDataSource
): CommonQuotaFormHierarchyKeys | undefined => {
  if (!isNullable(dataSource?.trend)) {
    return 'trendId'
  }

  if (!isNullable(dataSource?.purchasingGroup)) {
    return 'purchasingGroupId'
  }

  if (!isNullable(dataSource?.commodityGroup)) {
    return 'commodityGroupId'
  }

  if (!isNullable(dataSource?.category)) {
    return 'categoryId'
  }

  if (!isNullable(dataSource?.subcategory)) {
    return 'subcategoryId'
  }
}
